import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MotifButtonModule, MotifIconModule } from '@ey-xd/ng-motif';
import { TranslatePipe } from '@ngx-translate/core';
import { FULL_HOME_ROUTE } from '@routes';
import { EytcAuthService } from '@services/authentication/eytc-auth.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-login',
  imports: [MotifButtonModule, MotifIconModule, TranslatePipe],
  templateUrl: './login.component.html',
  standalone: true,
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {
  private gtesAuth = inject(EytcAuthService);
  private router = inject(Router);

  #router: Router = inject(Router);

  async login() {
    this.gtesAuth.init();

    combineLatest({
      isLoggedIn: this.gtesAuth.getUserLoginState$(),
    }).subscribe(async () => {
      await this.#router.navigate([FULL_HOME_ROUTE]);
    });
  }
}
